import axios from 'axios';

export const getVenuesAdmin = () => axios.get('/venues/admin');
export const getVenueByIdAdmin = (id) => axios.get(`/venues/admin/${id}`);
